<template>
  <div :class="$route.name == '/homework_report_topic' ? 'wrapper_pad' : 'wrapper2'">
    <el-dialog
      title="习题详情"
      :visible.sync="dialogVisible"
      width="50%"
      custom-class="topic_detail_dia"
    >
      <div>
        <div v-html="topic_detail.content"></div>
        <div>[答案]</div>
        <div v-html="topic_detail.answer"></div>
        <div>[解析]</div>
        <div v-html="topic_detail.analyzing"></div>
      </div>
    </el-dialog>
    <el-dialog
      title="学生答案"
      :visible.sync="dialogVisible_answer"
      width="50%"
      custom-class="topic_detail_dia"
      center
    >
      <div>
        <div
          v-for="(url, index) in student_answer_detail.student_answer_small"
          :key="index"
        >
          <div style="color: red">{{ index + 1 }}.</div>
          <el-image :src="url.thumbnail || url.image" lazy></el-image>
        </div>
        <div
          v-if="
            !student_answer_detail.student_answer_small &&
            !student_answer_detail.student_answer &&
            !student_answer_detail.is_unique
          "
        >
          暂未作答
        </div>
        <div v-if="student_answer_detail.is_unique">
          {{ student_answer_detail.student_answer }}
        </div>
        <!-- <div>{{student_answer}}</div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="student_answer_detail.student_answer_small"
          type="primary"
          @click="openIframe"
          >答题讲解</el-button
        >
      </span>
    </el-dialog>
    <el-drawer
      :visible.sync="show_iframe"
      direction="ltr"
      :with-header="false"
      size="100%"
    >
      <iframe
        v-if="show_iframe"
        :src="iframe_url"
        frameborder="0"
        style="width: 100%; height: 100%"
      ></iframe>
    </el-drawer>
    <div>
      <div class="ledt_box_all">
        <div class="ledt_box_all_head">习题列表</div>
        <div class="left_box">
          <div
            @click="choose_topic(item, index)"
            :class="topicList_index == index ? 'topicList_index_active' : ''"
            class="left_box_item flex-col-h-center"
            v-for="(item, index) in topicList"
            :key="index"
          >
            <!-- {{item.scoreRate}} -->
            <span v-if="item.scoreRate >= 80" style="color: #67c23a"
              >{{ item.scoreRate }}%</span
            >
            <span v-else style="color: red">{{ item.scoreRate }}%</span>
            <span>第{{ index + 1 }}题</span>
          </div>
        </div>
        <div></div>
      </div>
    </div>
    <div class="right_box">
      <div class="right_box_head">
        <div class="right_box_head_content" v-html="topic_detail.content"></div>

        <div class="right_box_head_foot">
          <span style="margin-right: 10px" @click="start(topic_detail)">习题讲解</span>
          <span @click="dialogVisible = true">查看更多</span>
        </div>
      </div>

      <div
        class="box_content"
        v-if="!topic_detail.is_unique || Array.isArray(topic_detail.childScore)"
      >
        <div class="listtitle flex-row-v-center">
          <div class="listtitleItem">分值：{{ topic_detail.src_score }}</div>
          <div class="listtitleItem">平均分：{{ topic_detail.average }}</div>
          <div class="listtitleItem">得分率：{{ topic_detail.scoreRate }}%</div>
          <div class="listtitleItem flex-row-v-center">
            <div class="listtitleItembox2"></div>
            >=平均分：{{ topic_detail.averageNum }}人
          </div>
          <div class="listtitleItem flex-row-v-center">
            <div class="listtitleItembox"></div>
            <span>&lt;</span>平均分：{{ topic_detail.underAverageNum }}人
          </div>
          <div class="listtitleItem flex-row-v-center">
            <div class="listtitleItemImg">
              <img src="../../assets/images/fullScoreNum.png" alt="" />
            </div>
            满分：{{ topic_detail.fullScoreNum }}人
          </div>
          <div class="listtitleItem" style="color: gray">
            <!-- <span style="color: gray"> 提示: </span>
            点击学生名字可查看学生答题情况 -->
          </div>
        </div>
        <div class="result_r_content">
          <div
            v-for="(item_student, index_student) in topic_detail.student"
            :key="index_student"
            class="flex-row-v-center result_r_contentBox"
          >
            <div class="result_r_content_item" @click="getDetail(item_student)">
              {{ item_student.name }}
            </div>
            <div
              class="scoreBox flex-center"
              v-if="item_student.topic.score >= Number(topic_detail.average)"
            >
              <div
                class="result_r_content_item_img"
                v-if="item_student.topic.score == Number(topic_detail.src_score)"
              >
                <img src="../../assets/images/fullScoreNum.png" alt="" />
              </div>
              <span class="scoreNum">{{ item_student.topic.score }}</span
              ><span style="font-size: 6px; color: #69b4ff">分</span>
            </div>
            <div class="scoreBox2 flex-center" v-else>
              <span class="scoreNum2">{{ item_student.topic.score }}</span
              ><span style="font-size: 6px; color: #ff9b36">分</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 选择题 -->
      <div class="box_content" v-else>
        <div class="listtitle flex-row-v-center">
          <div class="listtitleItem">分值：{{ topic_detail.src_score }}</div>
          <div class="listtitleItem">平均分：{{ topic_detail.average }}</div>
          <div class="listtitleItem">得分率：{{ topic_detail.scoreRate }}%</div>
          <div class="listtitleItem flex-row-v-center">
            <div class="listtitleItembox2"></div>
            正确答案
          </div>
          <div class="listtitleItem flex-row-v-center">
            <div class="listtitleItembox"></div>
            错误答案
          </div>
        </div>
        <div class="result_r_content2 flex-row">
          <div class="result_r_content2_left">
            <div
              v-for="(item, index) in topic_detail.uniqueList"
              :key="index"
              class="result_r_contentBox2"
              @click="selectUnique(item)"
            >
              <div
                :class="{
                  result_r_content_item2: true,
                  'flex-center': true,
                  result_r_content_item3_active: item.name == uniquedetail,
                  result_r_content_item2_active:
                    item.name == uniquedetail &&
                    topic_detail.answer.indexOf(item.name) > -1,
                }"
              >
                {{ item.list.length }}人
              </div>
              <!-- <div
                class="scoreBox flex-center"
                v-if="item_student.topic.score >= Number(topic_detail.average)"
              >
                <div
                  class="result_r_content_item_img"
                  v-if="
                    item_student.topic.score == Number(topic_detail.src_score)
                  "
                >
                  <img src="../../assets/images/fullScoreNum.png" alt="" />
                </div>
                <span class="scoreNum">{{ item.name}}</span
                ><span style="font-size: 6px; color: #69b4ff">分</span>
              </div> -->
              <div
                class="scoreBox4 flex-center"
                v-if="topic_detail.answer.indexOf(item.name) > -1"
              >
                <div class="result_r_content_item_img">
                  <img src="../../assets/images/fullScoreNum.png" alt="" />
                </div>
                <span class="scoreNum3">{{ item.name }}</span>
              </div>
              <div class="scoreBox3 flex-center" v-else>
                <span class="scoreNum2">{{ item.name }}</span>
              </div>
            </div>
          </div>
          <div class="result_r_content2_right flex-1 flex-row">
            <div
              class="result_r_content2_right_item flex-center"
              v-for="(data, key) in topic_detail.student"
              :key="key"
              v-show="data.topic.student_answer.indexOf(uniquedetail) > -1"
            >
              {{ data.name }}
            </div>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
import { unique1 } from "../../assets/js/common";
import screenfull from "screenfull"; //引入依赖

export default {
  data() {
    return {
      topicList: [],
      topicList_index: 0,
      topic_detail: {},
      dialogVisible: false,
      show_student_list_arr: [{ list: [] }],
      topic_accuracy: 0,
      right_box_content_right_lsit_active: 0,
      dialogVisible_answer: false,
      student_answer: [],
      canshow: false,
      topic_type: [],
      student_answer_detail: { student_answer_small: "" },
      uniquedetail: "A",
      show_iframe: false,
    };
  },
  mounted() {
    this.topicList_index = this.$route.query.index;
    this.get_correct_work();
    this.get_topic_type();
  },
  methods: {
    start(data) {
      let arr = [];
      arr.push(data);
      let formdata = {
        topics: JSON.stringify(arr),
        prepare_lessons: "prepare_lessons",
        tocanvas_roomId: 1,
        keyValue: sessionStorage.keyValue,
        userInfo: sessionStorage.userInfo,
        token: sessionStorage.token,
      };
      this.axios
        .post("/teacher/index/addotherdata", {
          jsondata: JSON.stringify(formdata),
        })
        .then((res) => {
          if (res.data.code == 1) {
            //screenfull.toggle();
            this.show_iframe = true;
            this.iframe_url =
              JSON.parse(sessionStorage.userInfo).school.server_url +
              "/myCanvas/online/myCanvas.html?wss_timestamp=" +
              Date.parse(new Date()) +
              "&id=" +
              res.data.data;
          }
        });
    },
    selectUnique(item) {
      this.uniquedetail = item.name;
    },
    getDetail(item) {
      this.student_answer_detail = item.topic;
      //item.topic.content = `<img src='${item.topic.student_answer_small[0].image}'></img>`
      // item.topic.content
      //this.start(item.topic)
      this.dialogVisible_answer = true;
    },
    openIframe() {
      let str = "";
      for (let i in this.student_answer_detail.student_answer_small) {
        str =
          str +
          `<div><img src='${this.student_answer_detail.student_answer_small[i].image}'></img></div>`;
      }
      this.student_answer_detail.content = str;
      this.start(this.student_answer_detail);
    },
    //获取题型/teacher/subject/getlist?subject_code=a0
    get_topic_type() {
      var formData = new FormData();
      formData.append("subject_code", sessionStorage.subject_code);

      this.axios
        .post(`/teacher/subject/getlist?subject_code=a0`, formData)
        .then((res) => {
          this.topic_type = JSON.parse(res.data.data.tiku_type.type_json);
        });
    },
    check_topic_type(type_id) {
      for (let i in this.topic_type) {
        if (this.topic_type[i].id == type_id) {
          return this.topic_type[i].n;
        }
      }
    },
    show_student_answer(item) {
      if (this.canshow) {
        this.dialogVisible_answer = true;
        this.student_answer = item.topic.student_answer;
      }
    },
    //切换习题
    choose_topic(item, index) {
      this.topic_detail = item;
      this.topicList_index = index;
      //this.setout_pieChart(this.topic_detail);
    },

    //获取学生答题情况
    get_correct_work() {
      var formData = new FormData();
      formData.append("class_id", this.$route.query.class_id);
      formData.append("batch_id", this.$route.query.batch_id);
      formData.append("homework_src_uuid", this.$route.query.homework_src_uuid);
      this.axios
        .post(`/school/Homework_Usages/homeworkUsagesBatchDetail`, formData)
        .then((res) => {
          let arr = res.data.data.data;
          let topicList = [];
          for (let i in arr) {
            let student_usages_json = JSON.parse(arr[i].student_usages_json);
            console.log(student_usages_json);
            for (let j in student_usages_json) {
              for (let h in student_usages_json[j].topicList) {
                if (i == 0) {
                  topicList.push(student_usages_json[j].topicList[h]);
                }
              }
            }
          }

          for (let i in topicList) {
            topicList[i].student = [];
            for (let j in arr) {
              let student_usages_json = JSON.parse(arr[j].student_usages_json);
              let arr_temp = [];
              for (let h in student_usages_json) {
                for (let o in student_usages_json[h].topicList) {
                  arr_temp.push(student_usages_json[h].topicList[o]);
                }
              }

              // console.log(arr[j])
              topicList[i].student.push({
                name: arr[j].name,
                topic: arr_temp[i],
              });
            }
          }
          for (let i in topicList) {
            let sum = topicList[i].student.length;
            let num = 0;
            let averageNum = 0;
            let scoreNum = 0;
            let fullScoreNum = 0;
            for (let a in topicList[i].student) {
              if (!Array.isArray(topicList[i].student[a].topic.score)) {
                num = num + Number(topicList[i].student[a].topic.score);
              } else {
                let z = 0;
                for (let d in topicList[i].student[a].topic.score) {
                  z = z + Number(topicList[i].student[a].topic.score[d]);
                }
                topicList[i].student[a].topic.score = z;
                num = num + Number(topicList[i].student[a].topic.score);
              }
            }
            topicList[i].average = (num / sum).toFixed(1);
            for (let h in topicList[i].student) {
              if (!Array.isArray(topicList[i].student[h].topic.score)) {
                if (
                  Number(topicList[i].student[h].topic.score) >= (num / sum).toFixed(1)
                ) {
                  averageNum = averageNum + 1;
                }
                if (Number(topicList[i].student[h].topic.score) > 0) {
                  scoreNum = scoreNum + 1;
                }
                if (
                  Number(topicList[i].student[h].topic.score) ==
                  Number(topicList[i].student[h].topic.src_score)
                ) {
                  fullScoreNum = fullScoreNum + 1;
                }
                topicList[i].scoreRate = (
                  ((num / (Number(topicList[i].student[h].topic.src_score) * sum)) *
                    10000) /
                  100
                ).toFixed(0); //得分率
              } else {
                let s = 0;
                for (let j in topicList[i].student[h].topic.score) {
                  s = s + Number(topicList[i].student[h].topic.score[j]);
                }
                topicList[i].student[h].topic.score = s;
                if (
                  Number(topicList[i].student[h].topic.score) >= (num / sum).toFixed(1)
                ) {
                  averageNum = averageNum + 1;
                }
                if (Number(topicList[i].student[h].topic.score) > 0) {
                  scoreNum = scoreNum + 1;
                }
                if (
                  Number(topicList[i].student[h].topic.score) ==
                  Number(topicList[i].student[h].topic.src_score)
                ) {
                  fullScoreNum = fullScoreNum + 1;
                }
                topicList[i].scoreRate = (
                  ((num / (Number(topicList[i].student[h].topic.src_score) * sum)) *
                    10000) /
                  100
                ).toFixed(0); //得分率
              }
            }
            topicList[i].fullScoreNum = fullScoreNum; //满分人数
            topicList[i].averageNum = averageNum; //大于平均分
            topicList[i].underAverageNum = sum - averageNum; //小于平均分
            console.log(fullScoreNum, averageNum, sum);
            //选择题
            if (topicList[i].is_unique != "" && !topicList[i].childScore) {
              let arr = [];
              let list = "";
              if (topicList[i].is_unique.indexOf("&") > -1) {
                list = topicList[i].is_unique.split("&");
              } else {
                list = topicList[i].is_unique.split("|");
              }

              for (let index in list) {
                let obj = {
                  name: list[index],
                  list: [],
                };
                for (let l in topicList[i].student) {
                  if (
                    topicList[i].student[l].topic.student_answer.indexOf(list[index]) > -1
                  ) {
                    obj.list.push(topicList[i].student[l]);
                  }
                }
                arr.push(obj);
              }
              topicList[i].uniqueList = arr;
            }
          }
          this.topicList = topicList;
          this.topic_detail = topicList[this.topicList_index];
        });
    },
    //封装计算得分率
    get_score_percent(data) {
      console.log(JSON.parse(JSON.stringify(data)));
      let score = 0;
      let score_all = 0;
      for (let i in data) {
        for (let j in data[i].list) {
          if (data[i].list[j].topic.score > 0) {
            score += Number(data[i].list[j].topic.score);
          }
          score_all += 5;
        }
      }

      this.topic_accuracy = (score * 100) / score_all || 0;
      // return score*100/score_all
    },

    //根据题型生成饼图
    setout_pieChart(item) {
      if (item.is_unique == "A|B") {
        this.canshow = false;
        //判断题
        let arr_unique = item.is_unique.split("|");
        let data = [];
        for (let i in arr_unique) {
          data.push({
            type: arr_unique[i],
            list: [],
          });
        }
        for (let i in item.student) {
          for (let j in data) {
            if (item.student[i].topic.student_answer == data[j].type) {
              data[j].list.push(item.student[i]);
            }
          }
        }
        let to_data = [];
        for (let i in data) {
          to_data.push({ name: data[i].type, value: data[i].list.length });
        }
        let show_student_list_arr = [];
        for (let i in data) {
          show_student_list_arr.push({
            title: data[i].type,
            list: data[i].list,
          });
        }

        this.show_student_list_arr = show_student_list_arr;
        this.drawPieChart(to_data);
        this.get_score_percent(show_student_list_arr);
        // console.log(this.get_score_percent(show_student_list_arr))
        //  console.log(JSON.parse(JSON.stringify(show_student_list_arr)) )
      } else if (item.is_unique.indexOf("|") != -1) {
        this.canshow = false;
        //单选题
        let arr_unique = item.is_unique.split("|");
        let data = [];
        for (let i in arr_unique) {
          data.push({
            type: arr_unique[i],
            list: [],
          });
        }
        for (let i in item.student) {
          for (let j in data) {
            if (item.student[i].topic.student_answer == data[j].type) {
              data[j].list.push(item.student[i]);
            }
          }
        }
        let to_data = [];
        for (let i in data) {
          to_data.push({ name: data[i].type, value: data[i].list.length });
        }
        let show_student_list_arr = [];
        for (let i in data) {
          show_student_list_arr.push({
            title: data[i].type,
            list: data[i].list,
          });
        }
        this.show_student_list_arr = show_student_list_arr;
        this.drawPieChart(to_data);
        // console.log(this.get_score_percent(show_student_list_arr))
        //  console.log(JSON.parse(JSON.stringify(show_student_list_arr)) )
        this.get_score_percent(show_student_list_arr);
      } else {
        if (item.is_unique.indexOf("&") != -1) {
          this.canshow = false;
        } else {
          this.canshow = true;
        }

        let data = [{ is_true: [] }, { no_true: [] }, { is_false: [] }];

        for (let i in item.student) {
          // console.log(item.student[i])
          if (item.student[i].topic.score == 5) {
            data[0].is_true.push(item.student[i]);
          } else if (item.student[i].topic.score == 2.5) {
            data[1].no_true.push(item.student[i]);
          } else if (item.student[i].topic.score == 0) {
            data[2].is_false.push(item.student[i]);
          }
        }
        let to_data = [];
        let show_student_list_arr = [];
        if (item.is_unique.indexOf("&") != -1) {
          to_data = [
            { name: "全对", value: data[0].is_true.length },
            //  {name:'半对半错',value:data[1].no_true.length},
            { name: "全错", value: data[2].is_false.length },
          ];
          show_student_list_arr = [
            { title: "全对", list: data[0].is_true },
            // {title:'半对半错',list:data[1].no_true},
            { title: "全错", list: data[2].is_false },
          ];
        } else {
          to_data = [
            { name: "全对", value: data[0].is_true.length },
            { name: "半对半错", value: data[1].no_true.length },
            { name: "全错", value: data[2].is_false.length },
          ];
          show_student_list_arr = [
            { title: "全对", list: data[0].is_true },
            { title: "半对半错", list: data[1].no_true },
            { title: "全错", list: data[2].is_false },
          ];
        }

        this.show_student_list_arr = show_student_list_arr;
        //  console.log(JSON.parse(JSON.stringify(show_student_list_arr)) )
        this.get_score_percent(show_student_list_arr);
        this.drawPieChart(to_data);
      }
      return;
      this.drawPieChart();
    },
    //生成饼图
    drawPieChart(data) {
      // let data=data
      // [
      //                 {value: 1, name: '优秀'},
      //                 {value: 2, name: '良好'},
      //                 {value: 3, name: '及格'},
      //                 {value: 4,name: '不及格'},

      //             ]
      // this.student_arr_type=data
      //  console.log(data)
      this.chartPie = echarts.init(document.getElementById("chartPie"));
      this.chartPie.setOption({
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: "10px",
          left: "center",
        },
        series: [
          {
            name: "答题情况",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: data,
            itemStyle: {
              normal: {
                color: function (params) {
                  //自定义颜色
                  let colorList = ["#69B4FF", "#FF9B36", "#E37CFD", "#FF3945"]; //定义颜色列表 方便不等长选项自行截取
                  return colorList[params.dataIndex];
                },
              },
            },
          },
        ],
      });
      // option && myChart.setOption(option);
    },
  },

  beforeDestroy() {},
};
</script>

<style>
.topic_detail_dia {
  background: #ffffff;
  border-radius: 36px;
}
</style>
<style scoped>
.wrapper2 {
  background: #f2f9ff;
  /* height: calc(100vh - 100px);
  padding: 22px 41px; */
  box-sizing: border-box;
  display: flex;
  height: 100%;
  /* overflow-y: auto; */
  /* margin: 0 360px; */
}
.wrapper_pad {
  background: #f2f9ff;
  height: calc(100vh - 44px);
  padding: 22px 41px;
  /* box-sizing: border-box; */
  display: flex;
  /* margin: 0 360px; */
}

.ledt_box_all {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 20px;
  width: 310px;
  height: calc(100% - 40px);
  overflow: hidden;
}
.ledt_box_all_head {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin: 16px;
  height: 28px;
  line-height: 28px;
}
.ledt_box_all_back {
  height: 20px;
  margin: 0 0 20px 0;
}
.ledt_box_all_back img {
  height: 20px;
  display: block;
  cursor: pointer;
}

.left_box {
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  flex: 1;
}
.left_box_item {
  width: 60px;
  height: 60px;
  background: #f3f3f3;
  border-radius: 12px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  text-align: center;
  /* line-height: 56px; */
  cursor: pointer;
  margin: 16px;
  margin-right: 0;
  margin-bottom: 0;
}
.topicList_index_active {
  background: #ff9b36 !important;
  color: #ffffff !important;
}
.right_box {
  margin-left: 25px;
  width: 1500px;
  display: flex;
  flex-direction: column;
}
.right_box_head {
  height: 220px;
  background: #ffffff;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 16px;
  box-sizing: border-box;
}
.right_box_head_title {
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.right_box_head_content {
  flex: 1;
  overflow: hidden;
}
.right_box_head_content>>>img{
  width:100%;
}
.right_box_head_foot {
  height: 20px;
  line-height: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #69b4ff;
  text-align: right;
  cursor: pointer;
}
.right_box_content {
  background: #ffffff;
  border-radius: 20px;
  margin-top: 20px;
  flex: 1;
  overflow: auto;
}

.right_box_content_left {
  width: 400px;
  overflow: hidden;
}
#chartPie {
  width: 360px !important;
  height: 600px !important;
}
.right_box_content {
  display: flex;
  flex: 1;
}
.right_box_content_right {
  width: 1080px;
  margin-left: 20px;
}
.right_box_content_right_lsit {
  height: 460px;
  background: #ffffff;
  border: 2px solid #69b4ff;
  border-radius: 46px 12px 46px 12px;
  margin-top: 20px;
  margin-right: 20px;
  display: flex;
  flex-direction: column;
}
.right_box_content_left_title {
  margin: 16px;
}
.right_box_content_right_lsit_head {
  display: flex;
  padding: 10px 30px;
  justify-content: space-between;
  height: 30px;
}
.right_box_content_right_lsit > div:nth-of-type(1) {
  height: 29px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 29px;
  cursor: pointer;
}
.right_box_content_right_lsit_active {
  color: #69b4ff !important;
}
.right_box_content_right_lsit_item {
  flex: 1;
}
.right_box_content_right_lsit_item {
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.right_box_content_right_lsit_item > div {
  height: 38px;
  background: #f4faff;
  border-radius: 26px 6px 26px 6px;
  line-height: 38px;
  padding: 0 20px;
  cursor: pointer;
  margin: 0 20px 20px 0;
}
.box_content {
  margin-top: 14px;
  height: 100%;
  background: #ffffff;
  border-radius: 12px;
}
.listtitle {
  padding: 10px;
  font-size: 18px;
  font-weight: bold;
}
.listtitleItem {
  margin-right: 30px;
}
.listtitleItembox {
  width: 40px;
  height: 20px;
  background: #ff9b36;
  margin-right: 5px;
}
.listtitleItembox2 {
  width: 40px;
  height: 20px;
  background: #69b4ff;
  margin-right: 5px;
}
.result_r_contentBox {
  margin: 40px 40px;
  position: relative;
  border-radius: 26px 26px 26px 26px;
  position: relative;
}
.result_r_content_item {
  background: #f4faff;
  border-radius: 26px 0px 0px 26px;
  padding: 10px 40px 10px 20px;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
}
.scoreBox {
  width: 60px;
  height: 60px;
  border: 5px solid #69b4ff;
  border-radius: 100%;
  background: #ffffff;
  position: absolute;
  right: -50px;
}
.scoreNum {
  font-size: 20px;
  color: #69b4ff;
}
.result_r_content {
  flex: 1;
  overflow: auto;
  padding: 10px 30px;
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
}
.scoreBox2 {
  width: 60px;
  height: 60px;
  border: 5px solid #ff9b36;
  border-radius: 100%;
  background: #ffffff;
  position: absolute;
  right: -50px;
}
.scoreNum2 {
  font-size: 20px;
  color: #ff9b36;
}
.scoreNum3 {
  font-size: 20px;
  color: #69b4ff;
}
.listtitleItemImg img {
  width: 50px;
  height: 40px;
  margin-right: 5px;
}
.result_r_content_item_img {
  position: absolute;
  top: -28px;
  right: 5px;
}
.result_r_content_item_img img {
  width: 50px;
  height: 40px;
}
.result_r_content2 {
}
.result_r_content2_left {
  padding: 10px;
}
.result_r_contentBox2 {
  margin: 60px 40px;
  position: relative;
  border-radius: 26px 26px 26px 26px;
  position: relative;
}
.result_r_content_item2 {
  background: #f4faff;
  border-radius: 0px 26px 26px 0px;
  padding: 10px 0px;
  width: 120px;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
}
.scoreBox3 {
  width: 60px;
  height: 60px;
  border: 5px solid #ff9b36;
  border-radius: 100%;
  background: #ffffff;
  position: absolute;
  top: -8px;
  left: -35px;
}
.scoreBox4 {
  width: 60px;
  height: 60px;
  border: 5px solid #69b4ff;
  border-radius: 100%;
  background: #ffffff;
  position: absolute;
  top: -8px;
  left: -35px;
}
.result_r_content2_right {
  padding: 20px;
  margin-top: 60px;
  margin-right: 30px;
  background: #f2f9ff;
  align-content: flex-start;
  flex-wrap: wrap;
  border-radius: 12px;
  margin-bottom: 20px;
}
.result_r_content2_right_item {
  width: 140px;
  height: 50px;
  margin: 20px;
  background: #ffffff;
  border-radius: 12px;
}
.result_r_content_item3_active {
  background: #ff9b36;
  color: #ffffff;
}
.result_r_content_item2_active {
  background: #69b4ff;
  color: #ffffff;
}
.iframebox {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
}
</style>
